var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-list-alt" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("tasks")) + "\n    ")
        ],
        1
      ),
      _c(
        "q-list",
        { staticClass: "q-mb-md" },
        [
          _c(
            "q-collapsible",
            {
              attrs: { icon: "fal fa-filter", label: _vm.$t("filter") },
              model: {
                value: _vm.show_filter,
                callback: function($$v) {
                  _vm.show_filter = $$v
                },
                expression: "show_filter"
              }
            },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("representative"),
                        clearable: ""
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.request({
                            pagination: {
                              page: 1,
                              rowsNumber: 10,
                              rowsPerPage: 5,
                              descending: false,
                              sortBy: null
                            }
                          })
                        }
                      },
                      model: {
                        value: _vm.representative,
                        callback: function($$v) {
                          _vm.representative = $$v
                        },
                        expression: "representative"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.statuses,
                        "float-label": _vm.$t("status"),
                        clearable: ""
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.request({
                            pagination: {
                              page: 1,
                              rowsNumber: 10,
                              rowsPerPage: 5,
                              descending: false,
                              sortBy: null
                            }
                          })
                        }
                      },
                      model: {
                        value: _vm.status,
                        callback: function($$v) {
                          _vm.status = $$v
                        },
                        expression: "status"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        "float-label": _vm.$t("start_date"),
                        type: "date",
                        format: "DD/MM/YYYY",
                        clearable: ""
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.request({
                            pagination: {
                              page: 1,
                              rowsNumber: 10,
                              rowsPerPage: 5,
                              descending: false,
                              sortBy: null
                            }
                          })
                        }
                      },
                      model: {
                        value: _vm.start_date,
                        callback: function($$v) {
                          _vm.start_date = $$v
                        },
                        expression: "start_date"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        "float-label": _vm.$t("end_date"),
                        type: "date",
                        format: "DD/MM/YYYY",
                        clearable: ""
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.request({
                            pagination: {
                              page: 1,
                              rowsNumber: 10,
                              rowsPerPage: 5,
                              descending: false,
                              sortBy: null
                            }
                          })
                        }
                      },
                      model: {
                        value: _vm.end_date,
                        callback: function($$v) {
                          _vm.end_date = $$v
                        },
                        expression: "end_date"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-3" },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("apply_filter"),
                        icon: "far fa-filter"
                      },
                      on: {
                        click: function($event) {
                          return _vm.request({
                            pagination: {
                              page: 1,
                              rowsNumber: 10,
                              rowsPerPage: 5,
                              descending: false,
                              sortBy: null
                            }
                          })
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c("q-table", {
        attrs: {
          data: _vm.tasks,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          selection: "multiple",
          selected: _vm.selected,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request,
          "update:selected": function($event) {
            _vm.selected = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _vm.selected.length > 0
                  ? _c("q-btn", {
                      staticClass: "q-mr-md",
                      attrs: {
                        color: "negative",
                        icon: "far fa-trash",
                        label: _vm.$t("remove")
                      },
                      on: {
                        click: function($event) {
                          _vm.confirm_remove = true
                        }
                      }
                    })
                  : _vm._e(),
                _c(
                  "q-btn-dropdown",
                  {
                    staticClass: "q-mr-sm",
                    attrs: { color: "secondary", icon: "fal fa-chart-line" },
                    model: {
                      value: _vm.dropdown_reports,
                      callback: function($$v) {
                        _vm.dropdown_reports = $$v
                      },
                      expression: "dropdown_reports"
                    }
                  },
                  [
                    _c(
                      "q-list",
                      { attrs: { link: "" } },
                      _vm._l(_vm.reports, function(report, index) {
                        return _c(
                          "q-item",
                          {
                            key: index,
                            nativeOn: {
                              click: function($event) {
                                return _vm.showReport(report)
                              }
                            }
                          },
                          [
                            _c("q-item-main", {
                              attrs: { label: _vm.$t(report.slug) }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("new")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "4traders_task",
                        params: { id: 0 }
                      })
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-th",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: { "indeterminate-value": "some" },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t(col.label)) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: { color: "primary" },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    { key: "operator_name", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.operator_name) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "task_date", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.format(props.row.task_date)) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "qty_tasks", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.qty_tasks) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "author_name", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.author_name) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "secondary",
                          icon: "far fa-list-alt",
                          disabled: props.row.status === 1 ? true : false
                        },
                        on: {
                          click: function($event) {
                            return _vm.showAnswers(props.row)
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "far fa-pencil-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$router.push({
                              name: "4traders_task",
                              params: { id: props.row.actions }
                            })
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "negative",
                          icon: "far fa-trash-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.confirmRemove(props.row.actions)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.request({ pagination: _vm.server_pagination })
            }
          },
          model: {
            value: _vm.show_answers,
            callback: function($$v) {
              _vm.show_answers = $$v
            },
            expression: "show_answers"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_answers = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("answers")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-sm" },
                  [
                    _vm._l(_vm.steps, function(step, index) {
                      return step.answered_collection && step.status != 4
                        ? _c(
                            "div",
                            { key: index, staticClass: "col-xs-12 col-sm-6" },
                            [
                              _c(
                                "q-card",
                                [
                                  _c("q-card-title", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          step.start_time
                                            ? step.start_time.slice(0, -3)
                                            : ""
                                        ) +
                                        "\n                                " +
                                        _vm._s(
                                          step.start_time && step.end_time
                                            ? " - "
                                            : ""
                                        ) +
                                        "\n                                " +
                                        _vm._s(
                                          step.end_time
                                            ? step.end_time.slice(0, -3)
                                            : ""
                                        ) +
                                        "\n                                " +
                                        _vm._s(
                                          step.start_time || step.end_time
                                            ? " / "
                                            : ""
                                        ) +
                                        "\n                                " +
                                        _vm._s(step.branch_name) +
                                        "\n                            "
                                    )
                                  ]),
                                  _c("q-card-separator"),
                                  _c(
                                    "q-card-actions",
                                    { staticClass: "justify-center" },
                                    [
                                      _c("q-btn", {
                                        staticClass: "q-mr-sm",
                                        attrs: {
                                          flat: "",
                                          label:
                                            _vm.$t("check_in") +
                                            " - " +
                                            (step.checkin_date
                                              ? _vm.formatDateTime(
                                                  step.checkin_date
                                                )
                                              : _vm.$t("not_realized"))
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.openMaps(
                                              step.checkin_lat,
                                              step.checkin_long,
                                              step.branch_lat,
                                              step.branch_long
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("q-card-separator"),
                                  _c(
                                    "q-card-main",
                                    [
                                      _c(
                                        "q-list",
                                        [
                                          _c(
                                            "q-collapsible",
                                            {
                                              attrs: {
                                                label: _vm.$t("answers")
                                              }
                                            },
                                            [
                                              _c(
                                                "q-list",
                                                {
                                                  attrs: {
                                                    "no-border": "",
                                                    highlight: ""
                                                  }
                                                },
                                                _vm._l(
                                                  step.answered_collection,
                                                  function(answer, index) {
                                                    return _c(
                                                      "q-item",
                                                      {
                                                        key: "a" + index,
                                                        attrs: { multiline: "" }
                                                      },
                                                      [
                                                        _c(
                                                          "q-item-main",
                                                          [
                                                            _c(
                                                              "q-item-tile",
                                                              {
                                                                attrs: {
                                                                  label: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                        " +
                                                                    _vm._s(
                                                                      answer.title
                                                                    ) +
                                                                    "\n                                                    "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "q-item-tile",
                                                              {
                                                                attrs: {
                                                                  sublabel: ""
                                                                }
                                                              },
                                                              [
                                                                answer.question_type ===
                                                                  "single_choice" ||
                                                                answer.question_type ===
                                                                  "dissertative"
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-italic"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                            " +
                                                                            _vm._s(
                                                                              answer
                                                                                .answer[0]
                                                                            ) +
                                                                            "\n                                                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                answer.question_type ===
                                                                "upload"
                                                                  ? _c("span", [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticStyle: {
                                                                            width:
                                                                              "100%",
                                                                            height:
                                                                              "auto"
                                                                          },
                                                                          attrs: {
                                                                            src:
                                                                              answer
                                                                                .answer[0]
                                                                          }
                                                                        }
                                                                      )
                                                                    ])
                                                                  : _vm._e(),
                                                                answer.question_type ===
                                                                "multiple_choices"
                                                                  ? _c(
                                                                      "q-list",
                                                                      {
                                                                        staticClass:
                                                                          "text-italic",
                                                                        attrs: {
                                                                          separator:
                                                                            "",
                                                                          "no-border":
                                                                            ""
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        answer.answer,
                                                                        function(
                                                                          answer_selected,
                                                                          index
                                                                        ) {
                                                                          return _c(
                                                                            "q-item",
                                                                            {
                                                                              key:
                                                                                "as" +
                                                                                index
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                                " +
                                                                                  _vm._s(
                                                                                    answer_selected
                                                                                  ) +
                                                                                  "\n                                                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("q-card-separator"),
                                  _c(
                                    "q-card-actions",
                                    { staticClass: "justify-center" },
                                    [
                                      _c("q-btn", {
                                        attrs: {
                                          flat: "",
                                          label:
                                            _vm.$t("check_out") +
                                            " - " +
                                            (step.checkout_date
                                              ? _vm.formatDateTime(
                                                  step.checkout_date
                                                )
                                              : _vm.$t("not_realized"))
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.openMaps(
                                              step.checkout_lat,
                                              step.checkout_long,
                                              step.branch_lat,
                                              step.branch_long
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    _vm._l(_vm.steps, function(step, index) {
                      return step.status === 4
                        ? _c(
                            "div",
                            { key: index, staticClass: "col-xs-12 col-sm-6" },
                            [
                              _c(
                                "q-card",
                                [
                                  _c("q-card-title", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          step.start_time
                                            ? step.start_time.slice(0, -3)
                                            : ""
                                        ) +
                                        "\n                                " +
                                        _vm._s(
                                          step.start_time && step.end_time
                                            ? " - "
                                            : ""
                                        ) +
                                        "\n                                " +
                                        _vm._s(
                                          step.end_time
                                            ? step.end_time.slice(0, -3)
                                            : ""
                                        ) +
                                        "\n                                " +
                                        _vm._s(
                                          step.start_time || step.end_time
                                            ? " / "
                                            : ""
                                        ) +
                                        "\n                                " +
                                        _vm._s(step.branch_name) +
                                        "\n                            "
                                    )
                                  ]),
                                  _c("q-card-separator"),
                                  _c(
                                    "q-card-actions",
                                    { staticClass: "justify-center" },
                                    [
                                      _c("q-btn", {
                                        staticClass: "q-mr-sm",
                                        attrs: {
                                          flat: "",
                                          label: "" + _vm.$t("canceled")
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("q-card-separator"),
                                  _c(
                                    "q-card-main",
                                    [
                                      _c(
                                        "q-list",
                                        [
                                          _c(
                                            "q-collapsible",
                                            {
                                              attrs: {
                                                label: _vm.$t("cancel_motive")
                                              }
                                            },
                                            [
                                              _c(
                                                "q-list",
                                                {
                                                  attrs: {
                                                    "no-border": "",
                                                    highlight: ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "q-item",
                                                    [
                                                      _c(
                                                        "q-item-main",
                                                        [
                                                          _c(
                                                            "q-item-tile",
                                                            {
                                                              attrs: {
                                                                label: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    step.observation_cancel
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("q-card-separator"),
                                  _c(
                                    "q-card-actions",
                                    { staticClass: "justify-center" },
                                    [
                                      _c("q-btn", {
                                        staticClass: "q-mr-sm",
                                        attrs: {
                                          flat: "",
                                          label: "" + _vm.$t("canceled")
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "100vw",
              maxWidth: "100vw",
              minHeight: "100vh"
            }
          },
          model: {
            value: _vm.show_report,
            callback: function($$v) {
              _vm.show_report = $$v
            },
            expression: "show_report"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_report = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("tasks")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.tasks_steps,
                      columns: _vm.columns_tasks_steps,
                      pagination: _vm.server_pagination_tasks_steps,
                      loading: _vm.loading_tasks_steps,
                      "row-key": "name",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination_tasks_steps = $event
                      },
                      request: _vm.request_tasks_steps
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                {
                                  key: "company_name",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.company_name) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "branch_name", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.branch_name) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "operator_full_name",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.operator_full_name) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "task_date", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.formatDateOnly(props.row.task_date)
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "task_status",
                                  attrs: { props: props, "auto-width": "" }
                                },
                                [
                                  _c(
                                    "q-chip",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        small: "",
                                        icon: _vm.getIconStatus(
                                          props.row.task_status
                                        ),
                                        color: _vm.getColorStatus(
                                          props.row.task_status
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.getStatus(
                                                props.row.task_status
                                              )
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "step_time", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.step_time) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "checkin_date",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.formatDateTime(
                                          props.row.checkin_date
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "checkout_date",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.formatDateTime(
                                          props.row.checkout_date
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "total_time", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        props.row.total_time &&
                                          props.row.total_time.days > 0
                                          ? props.row.total_time.days +
                                              " " +
                                              _vm.$t("days")
                                          : ""
                                      ) +
                                      " " +
                                      _vm._s(
                                        props.row.total_time
                                          ? props.row.total_time.time
                                          : ""
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "status",
                                  attrs: { props: props, "auto-width": "" }
                                },
                                [
                                  _c(
                                    "q-chip",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        small: "",
                                        icon: _vm.getIconStatus(
                                          props.row.status
                                        ),
                                        color: _vm.getColorStatus(
                                          props.row.status
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.getStatus(props.row.status)
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "collection_title",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.collection_title) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "qty_collection_questions",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        props.row.qty_collection_questions
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeTasks },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeTasks()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_tasks")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(_vm.$t("confirm_remove")) +
                " " +
                _vm._s(_vm.selected.length) +
                " " +
                _vm._s(_vm.$t(_vm.selected.length > 1 ? "events" : "event")) +
                "?"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }